import { toCanvas } from "html-to-image";

export const RATIO = 2.4; // matches the Marketplace card banner (wide)
const PLACEHOLDER = "data:image/gif;base64,R0lGODlhAQABAIAAAB4eHgAAACwAAAAAAQABAAACAkQBADs=";
const MAX_H = 5000;

// Render the chat's message list (full length, capped) into a canvas.
// Row controls (drag handle, menu) are hidden so only the content shows.
export async function snapshotNote(el) {
  // Lazy images further down the note haven't loaded yet — load them first.
  const imgs = [...el.querySelectorAll("img")].filter((i) => !i.complete);
  imgs.forEach((i) => { i.loading = "eager"; });
  await Promise.race([
    Promise.all(imgs.map((i) => new Promise((r) => { i.addEventListener("load", r, { once: true }); i.addEventListener("error", r, { once: true }); }))),
    new Promise((r) => setTimeout(r, 4000)),
  ]);
  const hidden = [...el.querySelectorAll('[data-snapshot-hide="true"]')];
  hidden.forEach((n) => { n.style.visibility = "hidden"; });
  try {
    return await capture(el);
  } finally {
    hidden.forEach((n) => { n.style.visibility = ""; });
  }
}

async function capture(el) {
  const height = Math.min(el.scrollHeight, MAX_H);
  const opts = {
    backgroundColor: "#0A0A0A",
    pixelRatio: Math.min(2, window.devicePixelRatio || 1),
    height,
    width: el.clientWidth,
    style: { margin: "0" }, // the list is mx-auto; the clone would keep the margin and shift off-canvas
    imagePlaceholder: PLACEHOLDER,
    cacheBust: false,
    // Skip hidden-for-snapshot nodes and broken images (a single failed <img>
    // makes html-to-image reject the whole capture).
    filter: (n) => !(n.dataset && n.dataset.snapshotSkip === "true")
      && !(n.tagName === "IMG" && (!n.complete || n.naturalWidth === 0)),
  };
  try {
    return await toCanvas(el, opts);
  } catch {
    return toCanvas(el, { ...opts, skipFonts: true });
  }
}

// Crop the box (in displayed px) out of the snapshot and return a JPEG blob.
export function cropToBlob(canvas, box, shownWidth) {
  const s = canvas.width / shownWidth;
  const out = document.createElement("canvas");
  out.width = 960;
  out.height = Math.round(960 / RATIO);
  out.getContext("2d").drawImage(canvas, box.x * s, box.y * s, box.w * s, box.h * s, 0, 0, out.width, out.height);
  return new Promise((res, rej) => out.toBlob((b) => (b ? res(b) : rej(new Error("crop failed"))), "image/jpeg", 0.86));
}
